import { defineStore } from 'pinia';

// TODO: GUGG Typescript
// interface State {
//   announcement: String;
//   cart: Array;
//   collectionArtworks: Array;
//   currentSlide: Array;
//   dataLoaded: Boolean;
//   isKeyboardUser: Boolean;
//   logoCanvases: Array;
//   overlay: Boolean;
//   routing: Boolean;
//   savedPosition: Boolean;
//   showBanner: Boolean;
//   token: String;
//   useBootstrap: Boolean;
//   utm: {
//    campaign: String;
//    medium: String;
//    source: String;
//   };
//   yPos: Number;
// }

export const useMainStore = defineStore('mainStore', {
  state: () => ({
    announcement: '',
    cart: [],
    collectionArtworks: [],
    currentSlide: [],
    dataLoaded: false,
    isKeyboardUser: false,
    logoCanvases: [],
    overlay: false,
    routing: false,
    savedPosition: false,
    showBanner: true,
    token: '',
    useBootstrap: false,
    utm: {
      campaign: '',
      medium: '',
      source: '',
    },
    yPos: 0,
  }),
  actions: {
    pushItem({ type, value }) {
      this[type].push(value);
    },
    setBoolean(value) {
      this[value] = !this[value];
    },
    setListItem({ type, id, value }) {
      this[type] = [...this[type].filter((item) => item.id !== id), { id, value }];
    },
    setValue({ type, value }) {
      this[type] = value;
    },
    emptyCart() {
      this.cart = [];
    },
    updateCart(obj) {
      if (obj.checked) {
        this.cart.push(obj.file);
      }

      if (!obj.checked) {
        for (let i = 0; i < this.cart.length; i++) {
          if (this.cart[i].uid === obj.file.uid) {
            this.cart.splice(i, 1);
          }
        }
      }
    },
  },
});
